const _RegisterForm = [
  {
    text: 'names',
    id: 'userNameText',
    type: 'text'
  },
  {
    text: 'last_names',
    id: 'userLastNameText',
    type: 'text'
  },
  {
    text: 'email',
    id: 'userEmailText',
    type: 'text'
  },
  {
    text: 'confirm_email',
    id: 'userConfirmEmailText',
    type: 'text'
  },
  {
    text: 'password',
    id: 'userPasswordText',
    type: 'password'
  },
  {
    text: 'confirm_password',
    id: 'userConfirmPasswordText',
    type: 'password'
  }
];

exports.getRegisterFormData = function () {
  return _RegisterForm;
};
